var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "pt-5 pt-md-9 pb-2 pb-md-5",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "hosting_cpanel_info",
                  params: {
                    id: _vm.$route.params.id
                  }
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    size: "20"
                  }
                },
                [_vm._v("mdi-keyboard-backspace")]
              ),
              _vm._v(" Go back to managing " + _vm._s(_vm.hosting.domain) + " ")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pt-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c("gg-card-header", [_vm._v(" Plan Change Status ")]),
              _c(
                "gg-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.items,
                      "hide-default-footer": "",
                      loading: _vm.loading
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.status",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mb-1",
                                attrs: {
                                  small: "",
                                  color: _vm.statusColor(item.status)
                                }
                              },
                              [_vm._v(" mdi-circle ")]
                            ),
                            _vm._v(" " + _vm._s(item.status) + " ")
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }